// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from 'react-icons/bs';
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from 'react-icons/bs'
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import {
  Menu,
  X,
  User,
  Gamepad2,
  Wallet,
  Users,
  History,
  Headphones,
  ShieldCheck,
  ChevronRight,
  Gift,
  LogIn
} from "lucide-react";

const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar मौजूद है
  if (sidebar) {
    // अगर mySidebar मौजूद है, तभी उसकी width पढ़ें
    const width = sidebar.offsetWidth;
    sidebar.style.left = `-${width}px`;
  }

  // सुनिश्चित करें कि Overlay मौजूद है
  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar और Overlay मौजूद हैं
  if (sidebar) {
    sidebar.style.left = "0";
  }
  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {


  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(`logout`, "POST", null, headers)

    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");

  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false)


  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log('beforeinstallprompt event was fired');
      setPromptInstall(e);
      setSupportsPWA(true)
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log('No promptInstall event available');
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी"
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme 
  const { theme, toggleTheme } = useTheme("light");
  const theme1 = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme1 === 'light' ? '#000' : 'black',
    color: theme1 === 'light' ? '#fff' : '#fff',
  };
  const styles1 = {
    backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
    color: theme1 === 'light' ? 'black !important' : '#fff !important',

  };
  const logo = theme1 === 'light' ? '/baji.png' : '/baji.png';

  const colorChange = () => {
    localStorage.setItem("theme", "#fff")
    toggleTheme('#fff')
  }

  useEffect(() => {
    localStorage.setItem("theme", "light")

  }, [])




  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>
            <div style={styles}>

              <div
                className="w3-sidebar w3-bar-block"
                id="mySidebar"
                style={{ paddingBottom: "70px" }}
              >

                <span className=" back_sidebar" onClick={w3_close}><img src="../close.png" /></span>
                <div className="sidebar-header-banner">
                  <Link
                    to={"/landing"}
                    className="sidebar-brand-link"
                    onClick={w3_close}
                  >
                    <picture className="pic-img avatar-glow-wrap">
                      {user && user?.avatar ? (
                        <img
                          src={baseUrl + `${user && user?.avatar}`}
                          alt="profile"
                          className="user-avatar-img"
                        />
                      ) : (
                        <img src="../baji.png" alt="profile" className="user-avatar-img" />
                      )}
                    </picture>
                    <div className="brand-title-group">
                      <h2 className="brand-name-text">BAJIGERLUDO</h2>
                      <span className="brand-sub-badge">Official Gaming</span>
                    </div>
                  </Link>

                  <button className="back_sidebar_btn" onClick={w3_close} aria-label="Close sidebar">
                    <X size={18} />
                  </button>
                </div>

                <div className="sidebar-nav-list">
                  <Link
                    to={"/Profile"}
                    className="w3-bar-item w3-button sidebar_link_modern"
                    onClick={w3_close}
                  >
                    <div className="icon-badge-box blue">
                      <User size={18} />
                    </div>
                    <h3>{translations[language]?.profile || "My Profile"}</h3>
                    <ChevronRight size={16} className="chevron-icon" />
                  </Link>

                  <Link
                    to={"/Homepage/ludoClassicManual"}
                    className="w3-bar-item w3-button sidebar_link_modern"
                    onClick={w3_close}
                  >
                    <div className="icon-badge-box green">
                      <Gamepad2 size={18} />
                    </div>
                    <h3>{translations[language]?.play || "Play"}</h3>
                    <ChevronRight size={16} className="chevron-icon" />
                  </Link>

                  <Link
                    to={"/wallet"}
                    className="w3-bar-item w3-button sidebar_link_modern"
                    onClick={w3_close}
                  >
                    <div className="icon-badge-box gold">
                      <Wallet size={18} />
                    </div>
                    <h3>{translations[language]?.wallet || "My Wallet"}</h3>
                    <ChevronRight size={16} className="chevron-icon" />
                  </Link>

                  {addCaseSetting?.isReferral ? (
                    <Link
                      to={"/refer"}
                      className="w3-bar-item w3-button sidebar_link_modern"
                      onClick={w3_close}
                    >
                      <div className="icon-badge-box purple">
                        <Users size={18} />
                      </div>
                      <h3>{translations[language]?.refer || "Refer and Earn"}</h3>
                      <ChevronRight size={16} className="chevron-icon" />
                    </Link>
                  ) : null}

                  <Link
                    to={"/history"}
                    className="w3-bar-item w3-button sidebar_link_modern"
                    onClick={w3_close}
                  >
                    <div className="icon-badge-box cyan">
                      <History size={18} />
                    </div>
                    <h3>{translations[language]?.history || "History"}</h3>
                    <ChevronRight size={16} className="chevron-icon" />
                  </Link>

                  <Link
                    to={"/support"}
                    className="w3-bar-item w3-button sidebar_link_modern"
                    onClick={w3_close}
                  >
                    <div className="icon-badge-box orange">
                      <Headphones size={18} />
                    </div>
                    <h3>{translations[language]?.support || "Support"}</h3>
                    <ChevronRight size={16} className="chevron-icon" />
                  </Link>
                </div>









              </div>
            </div>


            <div className="w3-teal" style={styles}>
              <div className="w3-container " style={styles}>
                <div className={`${css.headerContainer} `} style={styles}>
                  <button
                    className=" w3-xlarge float-left menu_button "
                    onClick={w3_open}
                    id="hambergar"
                  >

                    <img src="/menu.png" />
                  </button>
                  <Link to="/">
                    <img
                      src={logo}
                      className="snip-img filter-shadow"
                      alt="logos"
                      width="60px"
                      height="60px"
                    />
                  </Link>


                  {/* <div className="top_menu_bar_main" style={styles}>
                    <nav className={`${css.menu_items}`}>
                      <div className="header_navlink_main mr-0">

                      </div>
                      <div className="header_navlink_main ml-0">
                        <NavLink
                          exact
                          to="/Addcase"
                          className="top_menus_link wallet_balance_btn"
                          activeClassName=""
                        >
                          <img
                            className="header_img_wallet wallet_gif"
                            src="/images/icons/digital-wallet.png"
                            alt=""
                          />
                          <span>{user && user?.Wallet_balance}</span>
                        </NavLink>
                      </div>

                      <div className="header_navlink_main">
                        <NavLink
                          exact
                          to="/redeem/refer"
                          className="top_menus_link wallet_balance_btn ml-1 wallet_btn"
                          activeClassName=""
                        >
                          <img
                            className="header_img_wallet wallet_gif"
                            onClick={w3_close}
                            src="/images/referral-bonus.png"
                            alt=""
                          />
                          <span>
                            {user && user.referral_wallet.toFixed(2)}
                          </span>
                        </NavLink>
                      </div>


                    </nav>
                  </div> */}
                  <div className="top_menu_bar_main">
                    <nav className={`${css.menu_items} flex-row-center`}>
                      <div className="header_navlink_main ml-0">
                        <NavLink
                          exact
                          to="/Addcase"
                          className="top_menus_link_modern wallet_balance_btn"
                          activeClassName=""
                        >
                          <div className="pill-icon-glow blue">
                            <Wallet size={15} />
                          </div>
                          <span className="balance-amount">₹{user && user?.Wallet_balance ? user.Wallet_balance : "0.00"}</span>
                        </NavLink>
                      </div>

                      <div className="header_navlink_main">
                        <NavLink
                          exact
                          to="/redeem/refer"
                          className="top_menus_link_modern wallet_balance_btn refer_pill"
                          activeClassName=""
                        >
                          <div className="pill-icon-glow purple">
                            <Gift size={15} />
                          </div>
                          <span className="balance-amount">
                            ₹{user && user?.referral_wallet ? Number(user.referral_wallet).toFixed(2) : "0.00"}
                          </span>
                        </NavLink>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/baji.png"
                      className="snip-img"
                      alt="STARKINGADDA"
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
